import AccountHeaderElement from '../wishlist/elements/AccountHeaderElement'
import AccountSlideoutElement from '../wishlist/elements/AccountSlideoutElement'
import ValidateFormCustomElement from '../wishlist/elements/ValidateFormCustomElement'

function onInit() {
  window.customElements.define('account-header', AccountHeaderElement)
  window.customElements.define('account-slideout', AccountSlideoutElement)
  window.customElements.define('validate-form', ValidateFormCustomElement)
}

onInit()